module.exports = {"version":"0.20.6"}


//////////////////
// WEBPACK FOOTER
// ./~/web3/lib/version.json
// module id = 1214
// module chunks = 0